/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `in_person` - Prezenční * `online` - Online * `hybrid` - Kombinované
 */
export type StudyTypeEnum = 'in_person' | 'online' | 'hybrid';

export const StudyTypeEnum = {
    InPerson: 'in_person' as StudyTypeEnum,
    Online: 'online' as StudyTypeEnum,
    Hybrid: 'hybrid' as StudyTypeEnum
};